var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95892 5.41699H7.04225V8.12533H5.95892V5.41699ZM5.95837 8.66699H7.04171V9.75033H5.95837V8.66699Z",
    fill: "#BE3129"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45768 2.27545C7.26918 1.92065 6.90193 1.7002 6.50001 1.7002C6.0981 1.7002 5.73085 1.92065 5.54235 2.27599L1.5676 9.78511C1.4794 9.95001 1.43571 10.1351 1.44083 10.322C1.44596 10.5089 1.49974 10.6913 1.59685 10.8511C1.69256 11.0116 1.82848 11.1445 1.99121 11.2364C2.15393 11.3284 2.33782 11.3763 2.52472 11.3754H10.4753C10.8588 11.3754 11.206 11.1794 11.4037 10.8511C11.5007 10.6912 11.5544 10.5089 11.5595 10.322C11.5646 10.1351 11.521 9.95006 11.433 9.78511L7.45768 2.27545ZM2.52472 10.2921L6.50001 2.78299L10.478 10.2921H2.52472Z",
    fill: "#BE3129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.cb0ef5ffdfebe92b96cbe77356e88c76.svg";
export { ForwardRef as ReactComponent };